// src/legal/DataPrivacy.jsx
import React from "react";
import { ReactComponent as DSVGO_icon } from "../icons/DSVGO_icon.svg";


export function DataPrivacy() {
  const wrap = {
    borderRadius: 12,
    background: "#1B202B",
    border: "1px solid rgba(77,100,141,0.9)",
    boxShadow:
      "inset 0 1px 0 rgba(255,255,255,.04), 0 8px 18px rgba(0,0,0,.85)",
    padding: "16px 18px 18px",
    boxSizing: "border-box",
    height: "100%",
    overflowY: "auto",
  };

  const h1 = {
    fontFamily: "DisplayBadge, system-ui, sans-serif",
    fontSize: "var(--fs-18, 18px)",
    letterSpacing: ".18em",
    textTransform: "uppercase",
    color: "#ff8800",
    margin: "0 0 12px",
  };

  const h2 = {
    fontSize: "var(--fs-12, 12px)",
    letterSpacing: ".1em",
    textTransform: "uppercase",
    marginTop: 15,
    marginBottom: 0,
    color: "#82c3ff",
  };

  const p = {
    fontSize: "var(--fs-12, 12px)",
    lineHeight: 1.1,
    color: "rgba(220,230,245,0.88)",
    margin: "1px 0",
  };

  const small = {
    fontSize: 12,
    lineHeight: 1.5,
    color: "rgba(180,190,210,0.75)",
    marginTop: 10,
  };

  const codeBox = {
    fontFamily: " DisplayBadge ",
    fontSize: 11,
    background: "rgba(0,0,0,0.25)",
    borderRadius: 2,
    padding: "6px 8px",
    marginTop: 6,
    marginBottom: 6,
  };

  return (
    <div style={wrap}>
     <h1 style={{
    ...h1,
    display: "flex",
    alignItems: "center",
    gap: 6,
    marginBottom: 30,
  }}
>
  <DSVGO_icon
    width={28}
    height={28}
    aria-hidden="true"
    style={{ flexShrink: 0, transform: "translateY(-0.5px)" }}
  />
  <span>Datenschutzerklärung</span></h1>

      {/* Anbieter */}
      <h2 style={h2}>1. Verantwortlicher im Sinne der EU-Datenschutz-Grundverordnung (DSGVO):</h2>
      <p style={p}>mts individual carstyling GmbH</p>
      <p style={p}>Rilkestrasse 32b</p>
      <p style={p}>37120 Bovenden</p>
      <p style={p}>Deutschland</p>

      <div style={{ height: 6 }} />

      <p style={p}>
        Telefon: 0551 291 250 30
        <br />
        E-Mail: info@legendstools.de, support@mts-carstyling.de
        <br />
        Web: https://legendstools.de
      </p>

      {/* Vertretungsberechtigter */}
      <h2 style={h2}>2. Art der Datenverarbeitung</h2>
      <p style={p}>Beim Aufrufen unserer Website werden automatisch technisch notwendige Daten verarbeitet, 
      die dein Browser an unseren Hosting-Anbieter (STRATO AG) übermittelt. Dazu zählen:</p>
      <br />
      <p style={p}>• IP-Adresse (anonymisiert)</p>
      <p style={p}>• Datum und Uhrzeit des Zugriffs</p>
      <p style={p}>• Name der abgerufenen Datei</p>
      <p style={p}>• Referrer-URL</p>
      <p style={p}>• verwendeter Browser & Betriebssystem</p>
      <p style={p}>• übertragene Datenmenge</p>
      <br />
      <p style={p}>STRATO speichert diese Daten gemäß Art. 6 Abs. 1 lit. f DSGVO zur Sicherstellung des technischen Betriebs und der IT-Sicherheit.
      Eine persönliche Zuordnung findet nicht statt.</p>


      {/* 3. COOKIES */}
      <h2 style={h2}>3. Cookies (nur technisch notwendige)</h2>
      <p style={p}>Unsere Website verwendet ausschließlich technisch notwendige Cookies, um:</p>
      <br />
      <p style={p}>• Login-Informationen im Accountbereich zu speichern</p>
      <p style={p}>• Spracheinstellungen und Darstellungsoptionen zu merken</p>
      <p style={p}>• sicherzustellen, dass grundlegende Funktionen stabil arbeiten</p>
      <br />
      <p style={p}>Hinweis: Es kommen keine Analyse-, Tracking-, Marketing- oder Drittanbieter-Cookies zum Einsatz.
       Daher ist kein Cookie-Banner erforderlich (Art. 6 Abs. 1 lit. f DSGVO).</p>


      {/* 4. KONTAKT */}
      <h2 style={h2}>4. Kontaktaufnahme</h2>
      <p style={p}>
      Wenn du uns per E-Mail kontaktierst, verarbeiten wir die von dir angegebenen Daten ausschließlich zur Bearbeitung deiner Anfrage.
      Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.
      </p>

      {/* 5. Drittanbieter & Hosting */}
      <h2 style={h2}>5. Drittanbieter & Hosting</h2>
      <p style={p}>
        Unsere Website wird bei STRATO AG, Otto-Ostrowski-Straße 7, 10249 Berlin gehostet.
       Mit STRATO besteht ein Vertrag zur Auftragsverarbeitung gemäß Art. 28 DSGVO.
       Es werden keine weiteren Drittanbieter wie Google Analytics, Cloudflare, Matomo, Facebook/Meta oder Werbenetzwerke eingesetzt.</p>
      

      {/* 6. Registrierung & Benutzerkonto */}
      <h2 style={h2}>6. Registrierung & Benutzerkonto</h2>
      <p style={p}>
      Wenn du ein Benutzerkonto auf legendstools.de anlegst, speichern wir:</p>
      <br />
      <p style={p}>• E-Mail-Adresse</p>
      <p style={p}>• Passwort (ausschließlich verschlüsselt)</p>
      <p style={p}>• freiwillige Profilangaben</p>
      <p style={p}>• interne Nutzungsdaten (z. B. Serverauswahl, Tool-Einstellungen)</p>
      <br />
      <p style={p}>Diese Daten sind notwendig, um dir unser Angebot bereitstellen zu können (Art. 6 Abs. 1 lit. b DSGVO).</p>
      <p style={p}>Ein Account kann jederzeit gelöscht werden. Alle zugehörigen Daten werden unmittelbar entfernt,
      sofern keine gesetzlichen Aufbewahrungsfristen bestehen.</p>

      <h2 style={h2}>7. Datenübermittlung an Empfänger außerhalb des Europäischen Wirtschaftsraums</h2>
      <p style={p}>
      Es findet keine Übermittlung deiner Daten in Länder außerhalb der EU statt.
      </p>

      <h2 style={h2}>8. Speicherdauer</h2>
      <p style={p}>Personenbezogene Daten speichern wir nur so lange, wie es:</p>
      <br />
      <p style={p}>• für die bereitgestellten Funktionen notwendig ist</p>
      <p style={p}>• gesetzliche Vorgaben (z. B. handels-/steuerrechtliche Fristen) verlangen</p>

      <h2 style={h2}>9. Betroffenenrechte (DSGVO)</h2>
      <p style={p}>• Auskunftsrecht:
      <br />
      Du hast das Recht, Auskunft über die von uns zu Deiner Person gespeicherten Daten zu erhalten.</p>
      <br />
      <p style={p}>• Berichtigungs- und Löschungsrecht:
      <br />
      Du kannst von uns die Berichtigung falscher Daten und - soweit die gesetzlichen 
      Voraussetzungen erfüllt sind - Löschung Deiner Daten verlangen.</p>
      <br />
      <p style={p}>• Einschränkung der Verarbeitung: 
      <br />
      Du kannst von uns - 
      soweit die gesetzlichen Voraussetzungen erfüllt sind - verlangen, dass wir die Verarbeitung Deiner Daten einschränken.</p>
      <br />
      <p style={p}>• Datenübertragbarkeit:
      <br />
      Solltest Du uns Daten auf Basis eines Vertrages oder einer Einwilligung bereitgestellt haben, 
      so kannst Du bei Vorliegen der gesetzlichen Voraussetzungen verlangen, dass Du die bereitgestellten Daten in einem 
      strukturierten, gängigen und maschinenlesbaren Format erhältst oder dass wir diese an einen anderen Verantwortlichen übermitteln.</p>
      <br />
      <p style={p}>• Widerspruch:
      <br />
      Du hast das Recht, aus Gründen, die sich aus Deiner besonderen Situation ergeben, jederzeit der 
      Datenverarbeitung durch uns zu widersprechen, soweit diese auf der Wahrung berechtigter Interessen beruht. 
      Sofern Du von Deinem Widerspruchsrecht Gebrauch machst, werden wir die Verarbeitung einstellen, es sei denn, 
      wir können zwingende schutzwürdige Gründe für die Weiterverarbeitung nachweisen, welche Deine Rechte und Interessen überwiegen.</p>
      <br />
      <p style={p}>• Der Kontakt zu uns und die Ausübung Deiner Rechte:
      <br />
      Du kannst Dich bei Fragen zur Verarbeitung Deiner personenbezogenen 
      Daten und zu den Betroffenenrechten unentgeltlich mit uns in Verbindung setzen. Wende Dich bitte an datenschutz@mts-carstyling.de oder 
      postalisch an die oben unter Zif fer 1 angegebene Anschrift. Bitte stelle dabei sicher, dass uns eine eindeutige Identifizierung Deiner Person möglich ist.
      Beim Widerruf der Einwilligung kannst Du alternativ auch den Kontaktweg wählen, den Du bei der Abgabe der Einwilligung verwendet hast.  </p>

      <h2 style={h2}>10. Einsatz von KI</h2>
      <p style={p}>Auf unserer Website selbst kommt keine künstliche Intelligenz zum Einsatz.
       Eine Datenverarbeitung oder ein Support mit KI erfolgt nicht.</p>

       <h2 style={h2}>11. Stand</h2>
      <p style={p}>Es gilt die jeweilige aktuelle Version dieser Datenschutzerklärung. Version 1.1 – Stand: 18.11.2025.</p>


      <div style={small}>
      Copyright © 2025 mts individual carstyling GmbH, Germany. Alle Rechte vorbehalten.
      <br />
      Legendstools ist ein digitales Angebot der mts individual carstyling GmbH.
      mts individual® ist eingetragenes Warenzeichen der mts individual carstyling GmbH. 
      </div>
    </div>
  );
}


